import styled, { css } from 'styled-components';
import { UiColors } from 'assets/styles/old/global';

export const Group = styled.div`
  padding: 8px 0;

  & + & {
    border-top: 1px solid ${UiColors.strokeColor};
    margin-top: 4px;
    padding-top: 12px;
  }
`;

export const GroupLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 16px 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${UiColors.brownColor};

  ${({ collapsed }) =>
    collapsed &&
    css`
      display: none;
    `}
`;

/* Pill rendered next to a group label (e.g. applied-filters count). Defaults to the warn palette. */
export const GroupBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: ${UiColors.peachColor};
  color: ${UiColors.orangeColor};
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  white-space: nowrap;

  svg {
    width: 11px;
    height: 11px;
  }

  ${({ tone }) =>
    tone === 'neutral' &&
    css`
      background: ${UiColors.headerTableGray};
      color: ${UiColors.dimGreyFillColor};
    `}
`;

export const Item = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border: none;
  background: transparent;
  border-left: 3px solid transparent;
  text-align: left;
  font-size: 13px;
  color: ${UiColors.forestColor};
  cursor: pointer;
  position: relative;

  svg {
    flex: 0 0 auto;
    width: 15px;
    height: 15px;
    color: ${UiColors.dimGreyFillColor};
  }

  &:hover {
    background: ${UiColors.cloudColor};
  }

  ${({ active }) =>
    active &&
    css`
      background: ${UiColors.peachColor};
      border-left-color: ${UiColors.mangoColor};
      font-weight: 700;
      color: ${UiColors.forestColor};

      svg {
        color: ${UiColors.forestColor};
      }
    `}

  ${({ collapsed }) =>
    collapsed &&
    css`
      justify-content: center;
      padding: 12px 0;
      gap: 0;

      svg {
        width: 18px;
        height: 18px;
      }
    `}

  /* Indented child item (e.g. the Manage-assignments List/Map views nested under their parent). */
  ${({ sub, collapsed }) =>
    sub &&
    !collapsed &&
    css`
      padding-left: 38px;
      font-size: 12px;

      svg {
        width: 13px;
        height: 13px;
      }
    `}
`;

export const ItemLabel = styled.span`
  flex: 1;

  ${({ collapsed }) =>
    collapsed &&
    css`
      display: none;
    `}
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  background: ${UiColors.headerTableGray};
  color: ${UiColors.dimGreyFillColor};
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;

  ${({ tone }) =>
    tone === 'warn' &&
    css`
      background: ${UiColors.peachColor};
      color: ${UiColors.orangeColor};
    `}
`;

export const Dot = styled.span`
  position: absolute;
  top: 8px;
  right: 14px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${({ tone }) => (tone === 'warn' ? UiColors.mangoColor : UiColors.brownColor)};
`;
